import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@heroui/react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useTranslation } from "react-i18next";
import { useAppApi } from "src/appApi";
import { TRequest } from "@shared/entities";

const formSchema = z.object({
	adminMessage: z.string().min(1, { message: "יש להזין הודעה" }),
});

type Form = z.infer<typeof formSchema>;

export function AdminRequestExternalDocumentsModal({
	request,
	onSubmit,
}: {
	request: TRequest;
	onSubmit?: (request: Partial<TRequest>) => void;
}) {
	const { t } = useTranslation(["common", "admin"]);

	const appApi = useAppApi();

	const form = useForm<Form>({
		resolver: zodResolver(formSchema),
	});

	const _onSubmit = async (data: Form) => {
		if (!request.id) return;

		const res = await appApi.api.admin.requestExternalDocuments({
			id: request.id,
			adminMessage: data.adminMessage,
		});

		if (res?.success) {
			onSubmit?.(res.data);
		} else {
			form.setError("root", { message: "global error" });
		}
	};

	return (
		<ModalContent onSubmit={form.handleSubmit(_onSubmit, console.warn)} as={"form"}>
			{(onClose) => {
				return (
					<>
						<ModalHeader>בקש מסמכים חיצוניים</ModalHeader>
						<ModalBody className="">
							<Textarea
								label={t("common:message")}
								placeholder="הסבר איזה מסמכים חיצוניים נדרשים מהלקוח"
								{...form.register("adminMessage", {})}
								errorMessage={form.formState.errors.adminMessage?.message}
								isInvalid={!!form.formState.errors.adminMessage?.message}
							/>
						</ModalBody>
						<ModalFooter className="">
							<Button variant="light" onPress={onClose}>
								ביטול
							</Button>
							<Button
								isLoading={appApi.loading["admin.requestExternalDocuments"]}
								type="submit"
								color="primary"
							>
								אישור
							</Button>
						</ModalFooter>
					</>
				);
			}}
		</ModalContent>
	);
} 